export default "__VITE_ASSET__93d632d6__"